import { Droit } from './droit';

export class Utilisateur {
    constructor(
        public id: number,
        public nom: string,
        public prenom: string,
        public droit: string,
        public matricule: number,
        public mot_de_passe: string,
        public email: string,
        // tslint:disable-next-line:variable-name
        public droit_object: Droit,
    ){}
}

